<script setup lang="ts">
import Heading from '../General/Heading.vue'
import logoSrc from '../../assets/imgs/iclass-logo.svg'
import { TEXT } from '../../configs/text'
import { useI18n } from 'petite-vue-i18n'
import router from '../../configs/router';
import { useRoute } from 'vue-router';
import { RouteName } from '../../types/router';

const route = useRoute()

function handleChangeLogin(routeName: RouteName) {
    if (route.name === routeName) return;
    router.push({ name: routeName })
}

const { t } = useI18n()
</script>

<template>
    <div class="flex flex-col items-center justify-evenly h-full">
        <div class="grid grid-cols-2 w-full max-w-[500px] mt-auto">
            <div @click="handleChangeLogin(RouteName.login)" class="bg-neutral-300 hover:bg-neutral-200 transition-all p-3 rounded-t-lg cursor-pointer"
                :class="{ '!bg-white': route.name === RouteName.login }">
                <Heading alignment="center" class="!mb-0">{{ t(TEXT.login_as_student) }}</Heading>
            </div>
            <div @click="handleChangeLogin(RouteName.teacher_login)" class="bg-neutral-300 hover:bg-neutral-200 transition-all p-3 rounded-t-lg cursor-pointer"
                :class="{ '!bg-white': route.name === RouteName.teacher_login }">
                <Heading alignment="center" class="!mb-0">{{ t(TEXT.login_as_teacher) }}</Heading>
            </div>
        </div>
        <div class="rounded-b-lg bg-white w-full max-w-[500px] p-5 sm:p-14 mb-auto">
            <Heading alignment="center">{{ t(TEXT.welcome_to_iclass) }}</Heading>
            <img :src="logoSrc" class="mx-auto my-4 w-36" />
            <slot></slot>
        </div>
    </div>
</template>

<style scoped></style>